import PermissionsApi from "@/api/permissions";
import { RolesModel } from "@/domain/model/roles";

const loadRoles = async () => {
  return (await PermissionsApi.listMembershipGroups()) as RolesModel[];
};

export default loadRoles;
